angular.
module("digiexam.services").
filter("inArray", function inArray() {
	"use strict";
	return function filteredArray(sourceArray, filterArray, property) {
		if (sourceArray && filterArray) {
			if (property) {
				// Test if a property on an item is in the filterArray.
				return sourceArray.filter(function condition(item) {
					return filterArray.indexOf(item[property]) !== -1;
				});
			}
			// Test if an item is in the filterArray.
			return sourceArray.filter(function condition(item) {
				return filterArray.indexOf(item) !== -1;
			});
		}
		return [];
	};
});
